module.exports = __webpack_public_path__ + "img/q19.09bf3484.jpeg";